import {ADD_INVOICE_DETAIL_ABROAD_PAYMENT, UPDATE_INVOICE_DETAIL_ABROAD_PAYMENT,DELETE_INVOICE_DETAIL_ABROAD_PAYMENT,RESET_ABROAD_PAYMENT,SET_ISR_PERCENT_ABROAD_PAYMENT,GET_TABLE_DATA_ABROAD_PAYMENT_SERVICE} from '../../../../constants/ActionTypes'
import { ID } from '../../../../constants/Config'

const InitialState = {
    TableData: [],
    TableService:[],
    //percentItbis: null,
    ISRRetentionPercent:0,
   // itbisRetentionPercent:(100*0.01),
    IdCurrentRow: ID(),
   //  DynamicTaxInputs:[],
   //  DynamicInputValue:[]
}

function AbroadPaymentR(state = InitialState, action) {
    switch (action.type) {
        case ADD_INVOICE_DETAIL_ABROAD_PAYMENT:
            const NewRow = action.payload;
            return {
                ...state,
                TableData: [...state.TableData, NewRow],
                IdCurrentRow: ID()
            }
        case UPDATE_INVOICE_DETAIL_ABROAD_PAYMENT:
            const UpdateRow = action.payload;
            return {
                ...state,
                TableData: state.TableData.map(x => x.id === UpdateRow.id ? UpdateRow : x)
            }
        case DELETE_INVOICE_DETAIL_ABROAD_PAYMENT:
            const { productId } = action.payload;
            return {
                ...state,
                TableData: state.TableData.filter(x => x.productId !== productId)
            }
        case GET_TABLE_DATA_ABROAD_PAYMENT_SERVICE:

            let NewData=action.payload.map((data, index)=>(({
                ...data,
            })));

            return {
                ...state,
                TableService:NewData
            };
    
      //   case SET_DYNAMIC_TAX_INPUT_PROOF_OF_PURCHASE:
      //       return {
      //           ...state,
      //           DynamicTaxInputs:action.payload
      //       }
      //   case SET_DYNAMIC_INPUTS_VALUE_PROOF_OF_PURCHASE:
      //       return{
      //           ...state,
      //           DynamicInputValue:action.payload
      //       }
        case SET_ISR_PERCENT_ABROAD_PAYMENT:
            return {
                ...state,
                ISRRetentionPercent: action.payload*0.01
            }
        case RESET_ABROAD_PAYMENT:
            return {
                ...state,
                TableData: [],
                TableService:[],
                IdCurrentRow: ID(),
                //DynamicInputValue:[],
                ISRRetentionPercent:0
            }
        default:
            return state;
    }
}

export default AbroadPaymentR;